





























































































































































import {
  defineComponent,
  onMounted,
  ref,
  computed
} from "@vue/composition-api";
import { useGetters, useActions } from "vuex-composition-helpers";
import UserModel from "@/ts/models/userClass";
import useFetcher from "@use/useFetcher";
import CurrentTags from "@/vue/components/molecules/current/CurrentTags.vue";
import PageTitle from "@/vue/components/atoms/app/PageTitle.vue";
import BigAvatar from "@c/atoms/media/BigAvatar.vue";
import JoinButton from "@/vue/components/atoms/place/JoinButton.vue";
import OutlinedArea from "@/vue/components/molecules/app/OutlinedArea.vue";

export default defineComponent({
  name: "UserOverview",

  components: {
    CurrentTags,
    PageTitle,
    BigAvatar,
    JoinButton,
    OutlinedArea
  },

  setup(props, { root }) {
    const user_id = parseInt(root.$route.params.id);
    var { entity: user, loading } = useFetcher("user/GET_USER", {action_param:user_id});

    var show_email = ref(false);

    return {
      user,
      loading,
      show_email
    };
  }
});
